export default {
  toNum(ver) {
    const c = ver.toString().split('.');
    const np = ['', '0', '00', '000', '0000'];
    const r = np.reverse();
    for (let i = 0; i < c.length; i += 1) {
      const len = c[i].length;
      c[i] = r[len] + c[i];
    }
    return c.join('');
  },
  sortByKey(array, key) {
    return array.sort((a, b) => {
      const x = a[key];
      const y = b[key];
      if (x < y) {
        return -1;
      }
      if (x > y) {
        return 1;
      }
      return 0;
    });
  },
  sortByKeyDesc(array, key) {
    return array.sort((a, b) => {
      const x = a[key];
      const y = b[key];
      if (x < y) {
        return 1;
      }
      if (x > y) {
        return -1;
      }
      return 0;
    });
  },
  versionCompare(ver1, ver2) {
    const a = this.toNum(ver1);
    const b = this.toNum(ver2);
    if (a === b) return 'same';
    if (a > b) return 'low';
    return 'high';
  },
  toUnicode(theString) {
    let unicodeString = '';
    for (let i = 0; i < theString.length; i += 1) {
      let theUnicode = theString.charCodeAt(i).toString(16).toUpperCase();
      while (theUnicode.length < 4) {
        theUnicode = `0${theUnicode}`;
      }
      theUnicode = `\\u${theUnicode}`;
      unicodeString += theUnicode;
    }
    return unicodeString;
  },
  getFormatDate(date) {
    const y = date.getFullYear();
    const m = (date.getMonth() + 1).toString().padStart(2, '0');
    const r = date.getDate().toString().padStart(2, '0');
    const hh = date.getHours().toString().padStart(2, '0');
    const mm = date.getMinutes().toString().padStart(2, '0');
    const ss = date.getSeconds().toString().padStart(2, '0');
    return `${y}-${m}-${r} ${hh}:${mm}:${ss}`;
  },
  getFormatDay(date) {
    const y = date.getFullYear();
    const m = (date.getMonth() + 1).toString().padStart(2, '0');
    const r = date.getDate().toString().padStart(2, '0');
    return `${y}-${m}-${r}`;
  },
  getDaySpan(date1, date2) {
    const startDate = Date.parse(date1);
    const endDate = Date.parse(date2);
    if (startDate > endDate) {
      return 0;
    }
    if (startDate === endDate) {
      return 1;
    }
    const days = (endDate - startDate) / (1 * 24 * 60 * 60 * 1000);
    return days;
  },
  openUrl(url) {
    if (window.ctxBridge && window.ctxBridge.openExternal) {
      window.ctxBridge.openExternal(url);
    } else {
      window.open(url);
    }
  },
  sleep(time) {
    return new Promise((resolve) => setTimeout(resolve, time));
  },
  getToolName(name) {
    const newStr = name.split('_');
    let toolName = '';
    for (let i = 0; i < newStr.length; i += 1) {
      const str = newStr[i].slice(0, 1).toUpperCase() + newStr[i].slice(1).toLowerCase();
      toolName += str;
    }
    return toolName;
  },
  getTimeCost(time, unitMap) {
    const timeCost = time / 1000;
    let timeCostDisplay = '';
    if (timeCost < 60) {
      timeCostDisplay = `${timeCost} ${unitMap.second}`;
    } else if (timeCost >= 60 && timeCost < 3600) {
      timeCostDisplay = `${Math.trunc(timeCost / 60)} ${unitMap.minute} ${timeCost % 60} ${unitMap.second}`;
    } else {
      timeCostDisplay = `${Math.trunc(timeCost / 3600)} ${unitMap.hour} ${timeCost % 3600} ${unitMap.minute}`;
    }
    return timeCostDisplay;
  },

  getByteSizeDisplay(size) {
    let result = '';
    if (size < 1024) {
      result = `${size}KB`;
    } else if (size >= 1024 && size < 1073741824) {
      result = `${(size / 1048576).toFixed(2)}MB`;
    } else {
      result = `${(size / 1073741824).toFixed(2)}GB`;
    }
    return result;
  },
};
